module.exports = __webpack_public_path__ + "static/media/illu-header-clea@3x.16d2e653.png";